// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"4701":"svg-icons","8177":"remix-icons","9222":"blueprint-icons"}[chunkId] || chunkId) + "." + {"2091":"28026083","2570":"9d010338","4701":"3c18737f","4749":"44b19380","6926":"52bd5fa2","6994":"3b84a965","8177":"2bb5ac9f","9222":"c4499702"}[chunkId] + ".chunk.js";
};